import React from 'react';
import { Container, Nav, Navbar, Dropdown } from 'react-bootstrap';

import profilePic from '../../../assets/images/profile-pic.jpg';
import profilePicOne from '../../../assets/images/profile-pic-prosumer.jpg';

import ProfileNav from './profile/profile.nav';
//import LocalizationSelect from './localization/localization-select.nav';
//import { useTranslation } from 'react-i18next';
import { AuthUser, selectUser } from '../../../../src/slices/auth.slice';
import { useAppSelector } from '../../../app/hooks';
import solarSharelogo from '../../../assets/images/rex-logo.png';
import { NavLink } from 'react-router-dom';


function MainNavigation(props: any) {

  const activePath = props.activePath
  const auth = JSON.parse(localStorage.getItem('auth')!)
  //const { t, i18n } = useTranslation();
  let authUser: AuthUser = useAppSelector(selectUser);

  const profilePicImg = authUser.userType === 'Consumer' ? profilePic : profilePicOne;

  // let activeStyle = {
  //   color: 'gray'
  // };

  return (
    <Navbar expand="lg" >
      <Container>
        <Navbar.Brand>
          <img
            src={solarSharelogo}
            width="80"
            height="60"
            className="d-inline-block align-top"
            alt="Cnpp-logo"
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link active={(activePath === '/dashboard' ? true : false)}>
              <NavLink to="/dashboard" style={{ color: 'gray' }}>
                Dashboard
              </NavLink>
            </Nav.Link>
            {/* <Nav.Link href="/settlement" active={(activePath == '/settlement' ? true : false)}>Settlement</Nav.Link> */}
          </Nav>
          <Nav className="me-5">
            {/* <LocalizationSelect></LocalizationSelect> */}
          </Nav>
          <Nav className="ml-auto">
            <Dropdown className='nav-item'>
              <Dropdown.Toggle id="dropdown-basic" >
                <span className='profilePic'><img alt='profilePic' src={auth?.imageUrl ? auth?.imageUrl : profilePicImg} /></span>
                {authUser.userType === "Admin" ? "ADMINISTRATOR" : auth?.callingName}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <ProfileNav></ProfileNav>
              </Dropdown.Menu>
            </Dropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );

}
export default MainNavigation;
